import ChartWithDetailedTooltip from "./ChartWithDetailedTooltip";

export default ChartWithDetailedTooltip;
